class LeaseRecord {
  constructor(data) {
    this.abstract = data.abstract
    this.acreage = data.acreage
    this.block = data.block
    this.book = data.book
    this.classification = data.classification
    this.county = data.county
    this.endingPage = data.ending_page
    this.instrumentDate = data.instrument_date
    this.instrumentType = data.instrument_type
    this.legal = data.legal
    this.lessee = data.lessee
    this.lessor = data.lessor
    this.lot = data.lot
    this.meridian = data.meridian
    this.number = data.number
    this.numberOfPages = data.number_of_pages
    this.page = data.page
    this.porcion = data.porcion
    this.quarter = data.quarter
    this.range = data.range
    this.recordedDate = data.recorded_date
    this.section = data.section
    this.shares = data.shares
    this.source = data.source
    this.sourceUrl = data.source_url
    this.state = data.state
    this.subdivision = data.subdivision
    this.survey = data.survey
    this.township = data.township
    this.typeOfDocument = data.type_of_document
    this.vaultDataId = data.vaultDataId
  }
}

export default LeaseRecord
